/*
 * HoverMarker Messages
 *
 * This contains all the text for the HoverMarker component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  addPoint: {
    id: 'app.components.EditMarker.addPoint',
    defaultMessage: 'Extend route to this point',
  },
  insertPoint: {
    id: 'app.components.HoverMarker.insertPoint',
    defaultMessage: 'Insert point here',
  },
  walking: {
    id: 'app.components.HoverMarker.walking',
    defaultMessage: 'Walking route',
  },
  cycling: {
    id: 'app.components.HoverMarker.cycling',
    defaultMessage: 'Cycling route',
  },
  straight: {
    id: 'app.components.HoverMarker.straight',
    defaultMessage: 'Straight line',
  },
});
